export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">联系我们</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              欢迎各视频平台与我们联系合作，共同打造优质影视大全与热门视频合集
            </p>
          </div>

          <div className="bg-background-100 rounded-2xl border border-background-200/70 p-6 md:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
              <div className="group cursor-pointer">
                <div className="w-12 h-12 mx-auto rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
                  <i className="ri-mail-line text-xl text-primary-600 group-hover:text-background-50 transition-colors"></i>
                </div>
                <h3 className="mt-3 text-sm font-semibold text-foreground-900">商务合作</h3>
                <p className="mt-1 text-xs text-foreground-500">contact@qingqingcao.com</p>
              </div>

              <div className="group cursor-pointer">
                <div className="w-12 h-12 mx-auto rounded-xl bg-accent-100 flex items-center justify-center group-hover:bg-accent-500 transition-colors duration-300">
                  <i className="ri-chat-3-line text-xl text-accent-600 group-hover:text-background-50 transition-colors"></i>
                </div>
                <h3 className="mt-3 text-sm font-semibold text-foreground-900">内容投稿</h3>
                <p className="mt-1 text-xs text-foreground-500">submit@qingqingcao.com</p>
              </div>

              <div className="group cursor-pointer">
                <div className="w-12 h-12 mx-auto rounded-xl bg-secondary-100 flex items-center justify-center group-hover:bg-secondary-500 transition-colors duration-300">
                  <i className="ri-question-answer-line text-xl text-secondary-600 group-hover:text-background-50 transition-colors"></i>
                </div>
                <h3 className="mt-3 text-sm font-semibold text-foreground-900">问题反馈</h3>
                <p className="mt-1 text-xs text-foreground-500">feedback@qingqingcao.com</p>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-background-200/60 text-center">
              <p className="text-xs text-foreground-500">
                青青草视频持续拓展妖精视频、桃花视频、苹果视频、榴莲视频等平台合作，欢迎优质内容方加入
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}